import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { s3Static } from '../../utils/constants';

export const AppInstall = () => {
  return (
    <div className="container p-5">
       <div className="flex justify-center">
            <Link href="https://play.google.com/store/apps/details?id=com.stringssg.app" className="p-2" target="_blank">
                <Image  height={40} width={130} src={s3Static + "google-play-badge.png"} alt="StringsSG google play"/>
            </Link>
       		
            <Link href="https://itunes.apple.com/us/app/stringssg/id1347513244" className="p-2" target="_blank">
		  	        <Image className='bg-white rounded-lg' height={39} width={130} src={s3Static + "apple-store-badge.png"} alt="StringsSG apple store"/>
            </Link>
       </div>  			
    </div>
  )
}
